export default {
  data() {
    return {
      maxH: '',
      windowWidth: 0,
      windowHeight: 0,
      nobottommaxH: '',
      notbmaxH: ''
    }
  },
  mounted() {
    this.maxH = document.body.clientHeight - 175;
    this.windowWidth = window.innerWidth;
    this.windowHeight = window.innerHeight;
    this.nobottommaxH = document.body.clientHeight - this.cutH - 33;//底部没有分页
    this.notbmaxH = document.body.clientHeight - this.cutH + 14;//顶部没有新增返回搜索底部没有分页

    window.addEventListener("resize", this.windowResize, false)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.windowResize, false)
  },
  methods: {
    windowResize() {
      this.maxH = document.body.clientHeight - 175;
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
      this.nobottommaxH = document.body.clientHeight - this.cutH - 33;//底部没有分页
      this.notbmaxH = document.body.clientHeight - this.cutH + 14;//顶部没有新增返回搜索底部没有分页
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/windowResize.js